import { useCallback, useEffect, useMemo } from 'react'
import { stencil } from 'react-common'
import { TOCMenu } from '@/features/tocMenu/TOCMenu'
import { useIsMobileNew } from '@/hooks/useIsMobileNew'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { setContentMenuState } from '@/store/slices/layoutSlice'
import { TOCPluginTitle } from '../TOCPluginTitle/TOCPluginTitle'

const { TOCPlugin } = stencil

export const TOCPluginContainer = () => {
  const dispatch = useAppDispatch()
  const isMobile = useIsMobileNew()

  const isTOCPluginVisible = useAppSelector((state) => state.tocMenu.pluginEnabled)
  const isContentMenuOpen = useAppSelector((store) => store.layout.isContentMenuOpen)
  const tocItems = useAppSelector((state) => state.tocMenu.tocItems)

  const isOneLevel = useMemo(
    () => Boolean(tocItems?.children?.every((item) => item.children.length === 0)),
    [tocItems?.children],
  )

  const handleClose = useCallback(() => {
    dispatch(setContentMenuState(false))
  }, [dispatch])

  const handleOpen = useCallback(() => {
    dispatch(setContentMenuState(true))
  }, [dispatch])

  useEffect(() => {
    if (isMobile) {
      dispatch(setContentMenuState(false))
      return
    }

    dispatch(setContentMenuState(true))
  }, [dispatch, isMobile])

  if (!isTOCPluginVisible || !tocItems) {
    return null
  }

  const name = tocItems.root?.name
  const progress = tocItems.root?.progress
  const dueDate = tocItems.root?.dueDate

  return (
    <TOCPlugin
      title={<TOCPluginTitle name={name} progress={progress} dueDate={dueDate} />}
      isOpen={isContentMenuOpen}
      onOpen={handleOpen}
      onClose={handleClose}
    >
      <TOCMenu tocItems={tocItems} inlinedToComposition={isOneLevel} />
    </TOCPlugin>
  )
}
